import { Circle, Settings } from 'react-feather';

// permission modules
import modules from '@src/service/modules';

const manageModuleNav = [];

if (process.env.NODE_ENV === 'development') {
    manageModuleNav.push({
        id: 'module',
        title: 'Module',
        icon: <Circle size={12} />,
        navLink: '/module'
    });
}

export default [
    {
        id: 'settings',
        title: 'Settings',
        icon: <Settings size={20} />,
        dbId: modules.settings,
        children: [
            {
                id: 'project',
                title: 'Project',
                icon: <Circle size={12} />,
                navLink: '/settings/project-setting'
                // dbId: modules.setup_role
            },
            {
                id: 'menu-order',
                title: 'Menu Order',
                icon: <Circle size={12} />,
                navLink: '/settings/menu-order'
                // dbId: modules.setup_role
            },
            {
                id: 'email-template',
                title: 'Email Template',
                icon: <Circle size={12} />,
                navLink: '/settings/email-templates'
                // dbId: modules.setup_role
            },
            {
                id: 'configuration',
                title: 'Configuration',
                icon: <Circle size={12} />,
                navLink: '/settings/configuration'
                // dbId: modules.setup_role
            },
            ...manageModuleNav
        ]
    }
];
